// *********************************************************************************
// DO NOT ADD PASSWORDS, PRIVATE API KEYS, DATABASE DETAILS, OR SECRETS IN THIS FILE
// *****************************************************************************
// ****

// Store all app environment configs in one place - npm start (development)   npm run build (live)
const AppEnvironmentConfig = {

    // Store local development config
    development: {

        // Store the current app environment
        environment: "live",
        
        // Store the api version
        apiVersion: "test",

        // Keep registrations running normally in the test environment
        registrationMode: "register",

        // Store the local PHP base URL
        //phpBaseUrl: "http://192.168.178.45:8000/php",
        phpBaseUrl: "http://localhost:8000/php",

        // Store the development store URL
        storeUrl: "https://www.octofox.co.uk/dev/strichstoreUI/store",

        // Enable debug tools locally
        debug: true,

        // Show development-only Custom Products tools
        showCustomProducts: true,

        // Show store email template editing in development
        showEmailTemplates: true,

        // Store cart module URL
        cartUrl: "https://www.octofox.co.uk/dev/assets_modules/modules/cart/cart.js",

        // Store customizr module URL
        customizrUrl: "https://www.octofox.co.uk/dev/assets_modules/modules/customizr/customizr.js",

        // Store customizr logo URL
        customizrLogoUrl: "https://www.strichsuite.com/images/logo_wide.png",

        // Store POD inline module URL
        podInlineUrl: "https://www.octofox.co.uk/dev/assets_modules/modules/pod_inline/embed.js",

        // Store POD product preview module URL
        podProductPreviewUrl: "https://www.octofox.co.uk/dev/assets_modules/modules/pod_product_preview/pod_product_preview.js",

        // Store product module URL
        productModuleUrl: "https://www.octofox.co.uk/dev/assets_modules/modules/product/product.js",

        // Store placeholder image URL
        podInlinePlaceholderImageUrl: "https://www.strichsuite.com/images/logo_wide.png",

    },

    // Store live production config
    live: {

        // Store the current app environment
        environment: "live",

        // Store the api version
        apiVersion: "v2",

        // Hold registrations until the live launch is ready
        registrationMode: "register",

        // Store the live PHP base URL
        phpBaseUrl: "/php/",

        // Store the live store URL
        storeUrl: "https://strich.store",

        // Disable debug tools in live
        debug: false,

        // Hide development-only Custom Products tools
        showCustomProducts: false,

        // Hide store email template editing in live
        showEmailTemplates: false,

        // Store live cart module URL
        cartUrl: "https://assets.strichsuite.com/modules/cart/cart.js",

        // Store customizr module URL
        customizrUrl: "https://assets.strichsuite.com/modules/customizr/customizr.js",

        // Store customizr logo URL
        customizrLogoUrl: "https://www.strichsuite.com/images/logo_wide.png",

        // Store live POD inline module URL
        podInlineUrl: "https://assets.strichsuite.com/modules/pod_inline/embed.js",

        // Store live POD product preview module URL
        podProductPreviewUrl: "https://assets.strichsuite.com/modules/pod_product_preview/pod_product_preview.js",

        // Store live product module URL
        productModuleUrl: "https://assets.strichsuite.com/modules/product/product.js",

        // Store placeholder image URL
        podInlinePlaceholderImageUrl: "https://www.strichsuite.com/images/logo_wide.png",

    },

};

// Export the app environment config as a named export for validation scripts
export { AppEnvironmentConfig };

// Export the app environment config
export default AppEnvironmentConfig;